import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Lazy‑load page components
const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const OverviewPage = lazy(() => import('../pages/overview/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

/**
 * Route definitions for the application.
 * The file is now a `.tsx` module so JSX can be used safely.
 * Each route element is wrapped in `React.Suspense` to handle the loading state
 * of the lazily‑loaded components.
 */
const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <React.Suspense fallback={null}>
        <HomePage />
      </React.Suspense>
    ),
  },
  {
    path: '/services',
    element: (
      <React.Suspense fallback={null}>
        <ServicesPage />
      </React.Suspense>
    ),
  },
  {
    path: '/overview',
    element: (
      <React.Suspense fallback={null}>
        <OverviewPage />
      </React.Suspense>
    ),
  },
  {
    path: '/contact',
    element: (
      <React.Suspense fallback={null}>
        <ContactPage />
      </React.Suspense>
    ),
  },
  {
    path: '/privacy-policy',
    element: (
      <React.Suspense fallback={null}>
        <PrivacyPolicyPage />
      </React.Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <React.Suspense fallback={null}>
        <NotFound />
      </React.Suspense>
    ),
  },
];

export default routes;
